import React from "react";
import { Link } from "react-router-dom";
import "../../styles/raci-matrix.css";

const RACI_ROLES = ["R", "A", "C", "I"];

const ROLE_META = {
  R: "Responsible",
  A: "Accountable",
  C: "Consulted",
  I: "Informed",
};

const RACI_SORT_ORDER = { A: 0, R: 1, C: 2, I: 3 };

export const mapJobTasksToWorkflowJobs = (jobTasks) => {
  if (!Array.isArray(jobTasks)) return [];
  return jobTasks
    .filter((jt) => jt?.job?.job_id != null)
    .map((jt) => ({
      job_id: jt.job.job_id,
      name: jt.job.name || jt.job.job_name || "-",
      jobCode: jt.job.jobCode || jt.job.job_code || jt.job.code || "",
      role: jt.role ?? null,
      time_allocation_percentage: jt.time_allocation_percentage ?? null,
    }));
};

export const sortWorkflowJobsByRaci = (jobs = []) =>
  [...jobs].sort((a, b) => {
    const ao = RACI_SORT_ORDER[a.role] ?? 4;
    const bo = RACI_SORT_ORDER[b.role] ?? 4;
    if (ao !== bo) return ao - bo;
    return String(a.name || "").localeCompare(String(b.name || ""));
  });

export const RaciLegendBar = ({ className = "", style = {} }) => (
  <div className={`workflow-raci-legend ${className}`.trim()} style={style}>
    {RACI_ROLES.map((role) => (
      <div className="workflow-raci-legend-item" key={role}>
        <span className={`raci-legend-badge raci-${role.toLowerCase()}`}>
          {role}
        </span>
        <span>{ROLE_META[role]}</span>
      </div>
    ))}
  </div>
);

const WorkflowJobChips = ({
  jobs = [],
  emptyText = "-",
  taskId = null,
  showEditLink = false,
}) => {
  const sorted = sortWorkflowJobsByRaci(jobs);

  if (!sorted.length) {
    return <span style={{ color: "var(--gray-500)" }}>{emptyText}</span>;
  }

  return (
    <div className="workflow-job-chips-wrap">
      <div className="workflow-job-chips">
        {sorted.map((j) => {
          const code = j.jobCode || j.job_code || j.code || "";
          const roleKey = j.role ? j.role.toLowerCase() : "none";
          return (
            <span
              key={j.job_id}
              className={`workflow-job-chip${!j.role ? " workflow-job-chip-unassigned" : ""}`}
              title={
                j.role
                  ? `${ROLE_META[j.role]}${j.time_allocation_percentage != null ? ` · ${j.time_allocation_percentage}%` : ""}`
                  : "No RACI role assigned"
              }
            >
              <span className={`raci-badge raci-${roleKey}`}>
                {j.role || "—"}
              </span>
              <span className="workflow-job-chip-label">
                {j.name}
                {code ? ` - ${code}` : ""}
              </span>
            </span>
          );
        })}
      </div>
      {showEditLink && taskId && (
        <Link
          to={`/tasks/${taskId}/edit`}
          className="workflow-edit-raci-link"
          title="Edit RACI assignments for this task"
        >
          Edit RACI →
        </Link>
      )}
    </div>
  );
};

export default WorkflowJobChips;
